export default "__VITE_ASSET__DIY$t7V8__"